<template>
  <div>
    <b-card
      no-body
      style="font-size:18px; background-color:rgba(0, 0, 0, 0.6); color:#ffffff; border: 1px solid #00B058; border-radius: 20px;"
    >
      <b-row>
        <b-col
          lg="12"
          class="d-flex align-items-center justify-content-start mt-1 ml-1"
        >
          <b-img
            height="25"
            src="@/assets/images/icons/CDroad/Graph3.svg"
            class="mr-1"
          />
          <label style="color:white; font-size: 16px;">กราฟแสดงแรงดันไฟฟ้าภายในตู้ควบคุม 24 ชั่วโมง (Volt)</label>
        </b-col>
      </b-row>
      <div class="mt-1 ml-1">
        <app-echart-line :option-data="optionVolt" />
      </div>

    </b-card>
  </div>
</template>

<script>
import {
  BRow, BCol, BImg, BCard,
} from 'bootstrap-vue'
import axios from '@axios'
import AppEchartLine from './AppEchartLine.vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    AppEchartLine,
  },
  data() {
    return {
      items: [],
      voltPhase1: [],
      optionVolt: {
        xAxis: [
          {
            type: 'category',
            data: [],
            axisLabel: {
              color: '#fff',
            },
            splitLine: { show: false },
          },
        ],
        yAxis: [
          {
            max: '250',
            min: '220',
            type: 'value',
            splitLine: { show: false },
            axisLabel: {
              color: '#fff',
            },
          },
        ],
        grid: {
          width: '92%',
          left: '30px',
          top: '40px',
          containLabel: true,
        },
        series: [
          {
            name: 'Volt',
            type: 'line',
            showSymbol: false,
            smooth: true,
            data: [],
            color: '#00D8FF',
          },
        ],
      },
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.checkVolt()
    this.graphVolt()
    this.interval = setInterval(() => {
      this.checkVolt()
      this.graphVolt()
    }, 10000)
  },
  mounted() {
  },
  methods: {
    checkVolt() {
      if (this.$route.query.type !== 'iot4g') {
        axios
          .post('/checkVolt', { wid: this.$route.query.wid })
          .then(response => {
            this.items = response.data
            this.optionVolt.yAxis[0].max = this.items[0].MaxVolt
            this.optionVolt.yAxis[0].min = this.items[0].MinVolt
          })
          .catch(error => {
            console.log(error)
          })
      } else if (this.$route.query.type === 'iot4g') {
        axios
          .post('/checkVolt4G', { wid: this.$route.query.wid })
          .then(response => {
            this.items = response.data
            this.optionVolt.yAxis[0].max = this.items[0].MaxVolt
            this.optionVolt.yAxis[0].min = this.items[0].MinVolt
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    graphVolt() {
      if (this.$route.query.type !== 'iot4g') {
        axios.post('/graphVolt1Phase', { wid: this.$route.query.wid })
          .then(response => {
            this.resetVolt()
            // eslint-disable-next-line prefer-destructuring
            this.voltPhase1 = response.data
            this.voltPhase1.forEach(value => {
              this.optionVolt.xAxis[0].data.push(value.Period_Name)
              this.optionVolt.series[0].data.push(value.volt)
            })
          })
          .catch(error => {
            console.log(error)
          })
      } else if (this.$route.query.type === 'iot4g') {
        axios.post('/graphVolt1Phase4G', { wid: this.$route.query.wid })
          .then(response => {
            this.resetVolt()
            // eslint-disable-next-line prefer-destructuring
            this.voltPhase1 = response.data
            this.voltPhase1.forEach(value => {
              this.optionVolt.xAxis[0].data.push(value.Period_Name)
              this.optionVolt.series[0].data.push(value.volt)
            })
          })
          .catch(error => {
            console.log(error)
          })
      }
    },

    resetVolt() {
      this.voltPhase1.splice(0)
      this.optionVolt.xAxis[0].data.splice(0)
      this.optionVolt.series[0].data.splice(0)
    },
  },
}
</script>

<style lang="scss">
  .text1 {
    position: absolute;
    font-family: Arial;
    top: 20px;
    right: 20px;
    color: white;
  }
  </style>
